/* eslint-disable */
const prepareUrl = (url) => {
    return url.replace(/(^\w+:|^)\/\//, '//') + '/';
};

__webpack_public_path__ =  prepareUrl(window.PAAZL_CHECKOUT_WIDGET_RESOURCE_URL || process.env.RESOURCE_URL || "http://localhost:3000");
